import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconXProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconX: React.FC<IconXProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Close',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6 6 18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="m6 6 12 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconX;
